<template>
    <div>
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Contact HR </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->

        <div class="internal-page-main-section contact-page-main col-12">
            <div class="row">

                <div class="contact-section-main col-12 float-l">
                    <div class="container">
                        <div class="row">
                            <p class="color-333333 heading-text-20 line-height-24 width-full font-text-semi-medium-mont center"> Reach Out to us </p>

                            <h2 class="color-red heading-text-32 line-height-36 font-text-semi-medium-mont center pb-25 border-bottom-dddddd contact-title"> We’d love to hear from you </h2>

                            <p class="color-333333 heading-text-20 line-height-24 width-full font-text-semi-medium-mont center mt-20"> Get in touch and let us know how we can help</p>
                            <p class="color-333333 heading-text-20 line-height-24 width-full font-text-semi-medium-mont center mt-20"> If you have  a question regarding pay, <br/>employment verification or tax forms, please contact <a :href="'mailto:'+payroll"> Payroll </a></p>
                        </div>
                    </div>
                </div>


                <div class="bottom-contact-detail-main col-12 float-l">
                    <!--bottom-contact-detail-->
                    <div class="row">


                        <div class="container">
                            <div class="row">

                                <div class="view-btn-small contact-email-btn col-12">
                                    <div class="row">
                                        <a :href="'mailto:'+hr_email" class="hvr-sweep-to-right-blue"> Email Us </a>
                                    </div>
                                </div>

                                <div class="contact-detail col-12">
                                    <div class="row">

                                        <div class="contact-middle">
                                            <!--middle content-->
                                            <div class="contact-top-section float-l width-full">
                                                <!--top content-->
                                                <div class="left-call-icon col-12 col-sm-1 col-md-2 col-lg-2 float-l">
                                                    <div class="row">
                                                        <i class="hi-icon hr-call"> </i>
                                                    </div>
                                                </div>

                                                <div class="left-text-section col-12 col-sm-5 col-md-5 col-lg-5 float-l">
                                                    <div class="row">
                                                        <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full"> Can’t reach your onsite HR Admin? </p>

                                                        <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full mt-20"> Contact Us at </p>

                                                        <p class="color-blue heading-text-28 line-height-32 font-text-bold-mont float-l width-full mt-2"> <a :href="'tel:'+hr_admin_number" target="_blank">{{mobilenumber(mobilenumber(mobilenumber(hr_admin_number,0,'('),4,') '),9,'-')}}</a> </p>
                                                    </div>
                                                </div>

                                                <div class="left-text-section col-12 col-sm-5 col-md-5 col-lg-5 float-l">
                                                    <div class="row">
                                                        <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont float-l width-full"> To report a concern use our Employee Hotline at </p>

                                                        <p class="color-blue heading-text-28 line-height-32 font-text-bold-mont float-l width-full mt-20"> <a :href="'tel:'+employee_hotline"  target="_blank">{{mobilenumber(mobilenumber(mobilenumber(employee_hotline,0,'('),4,') '),9,'-')}}</a> </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--top content-->

                                            <div class="contact-bottom-section float-l width-full mt-80">
                                                <!--bottom content-->
                                                <div class="left-call-icon col-12 col-sm-1 col-md-2 col-lg-2 float-l">
                                                    <div class="row">
                                                        <i class="hi-icon hr-email"> </i>
                                                    </div>
                                                </div>

                                                <div class="left-text-section col-12 col-sm-5 col-md-5 col-lg-5 float-l">
                                                    <div class="row">
                                                        <a :href="'mailto:'+hr_email" class="color-333333 heading-text-18 line-height-22 font-text-semi-medium-mont float-l width-full"> {{hr_email}} </a>
                                                    </div>
                                                </div>

                                                <div class="right-social-media col-12 col-sm-5 col-md-5 col-lg-5 float-l">
                                                    <div class="row">
                                                        <!--<a href="#" class="btn-5"><span><i class="fa fa-facebook-f"></i>  </span></a>
                                                        <a href="#" class="btn-5"><span><i class="fa fa-twitter"></i>  </span></a>
                                                        <a href="#" class="btn-5"><span><i class="fa fa-instagram"></i>  </span></a>-->

                                                        <template v-for="(social,index) in socialMediaLinks">
                                                            <template v-if="social.social_title.value == 'facebook'">
                                                                <a :href="social.social_value" target="_blank" class="btn-5"><span><i class="fa fa-facebook-f"></i></span></a>
                                                            </template>
                                                            <template v-else-if="social.social_title.value == 'instagram'">
                                                                <a :href="social.social_value" target="_blank" class="btn-5"><span><i class="fa fa-instagram"></i></span></a>
                                                            </template>
                                                            <template v-else-if="social.social_title.value == 'linkedin'">
                                                                <a :href="social.social_value" target="_blank" class="btn-5"><span><i class="fa fa-linkedin"></i></span></a>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--bottom content-->

                                        </div>
                                        <!--middle content-->

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
                <!--bottom-contact-detail-->

            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    var self;
    export default {
        name: 'contact',
        mixins: [SessioMixin],
        data() {
            return {
                payroll: '',
                hr_email: '',
                hr_admin_number: '',
                employee_hotline: '',
                socialMediaLinks: '',
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.loadHRContact();
            self.getBuildVersion();
        },
        methods: {
            mobilenumber(string, position, addstring) {
                if ($.trim(string) === "" && string.length <= 0) {
                    return string;
                } else {
                    return [string.slice(0, position), addstring, string.slice(position)].join('');
                }
            },
            loadHRContact() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    /*params: {
                     'type': self.categoryType,
                     }*/
                };

                HTTP.get("getcontacthr", config)
                        .then(function (response) {
                            self.payroll = response.data.content.payroll_email;
                            self.hr_email = response.data.content.hr_email;
                            self.hr_admin_number = response.data.content.hr_admin_contact;
                            self.employee_hotline = response.data.content.employee_hotline;
                            self.socialMediaLinks = response.data.content.social_links;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Contact.vue